import { render, staticRenderFns } from "./HomePianiTerapeutici.vue?vue&type=template&id=4e21a7dc&"
import script from "./HomePianiTerapeutici.vue?vue&type=script&lang=js&"
export * from "./HomePianiTerapeutici.vue?vue&type=script&lang=js&"
import style0 from "./HomePianiTerapeutici.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports